var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomerprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    transform: "translate(-52 -565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    width: 25,
    height: 25,
    transform: "translate(52 565)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(56 569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M5.824,18H5.543a.766.766,0,0,1-.087-.006,14.872,14.872,0,0,1-4.272-.822C-.243,16.661-.088,15.486.168,13.538a3.381,3.381,0,0,1,2.313-2.617,6.012,6.012,0,0,0,6.755.023,3.4,3.4,0,0,1,2.246,2.592c.256,1.948.41,3.124-1.017,3.633a14.85,14.85,0,0,1-4.271.821h0A.556.556,0,0,1,6.106,18H5.824ZM13.2,15.045h-.231a.5.5,0,0,1-.057,0l-.016,0-.109-.005a21.228,21.228,0,0,0-.177-2.2A3.964,3.964,0,0,0,10.622,9.8a5.728,5.728,0,0,0,.483-.676,4.589,4.589,0,0,0,2.133.523,4.668,4.668,0,0,0,2.771-.919,2.967,2.967,0,0,1,1.851,2.322c.212,1.745.34,2.8-.837,3.253a11.386,11.386,0,0,1-3.522.735h0a.435.435,0,0,1-.07.006H13.28ZM1.075,5.988a4.8,4.8,0,1,1,4.8,4.787A4.793,4.793,0,0,1,1.075,5.988ZM11.566,8.174a5.842,5.842,0,0,0,.372-2.061A5.686,5.686,0,0,0,10.011,1.8,3.885,3.885,0,0,1,13.238,0,4.137,4.137,0,0,1,17.2,4.286a4.138,4.138,0,0,1-3.958,4.287A3.68,3.68,0,0,1,11.566,8.174Z",
    fill: "#b5b5b5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerprofile);
export default __webpack_public_path__ + "static/media/customerprofile.f2ea50a36f11ccade1a19ffbb976671d.svg";
export { ForwardRef as ReactComponent };